export default "__VITE_ASSET__CquwNp7z__"